export default "__VITE_ASSET__FPKKH7UU__"